import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=fc65cea0&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=fc65cea0&lang=stylus&scoped=true&"
import style1 from "./Menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc65cea0",
  null
  
)

export default component.exports